// autopilot-schema-command.ts
//
// F2 (plan 20260915-1650, phase-01, spec "schema sinh từ code là chân lý; tài
// liệu chỉ là hướng dẫn — agent phải hỏi schema thật trước khi tạo payload").
// `avatar autopilot schema <name>` prints the JSON Schema derived from the zod
// source at runtime — byte-for-byte the text `npm run schemas:generate`
// writes into team-ai-pack `templates/autopilot/<name>.schema.json` (same
// generateJsonSchemaText, so a stale pack copy can never disagree with what
// this prints). Reads no mission state, takes no credentials, writes no file.
// Only autopilot payloads have zod sources (schemas/index.ts); the other CLI
// commands are commander-typed, which is why there is no `--schema` flag on
// them (plan "không làm").
// ⚠️ Import the PURE helper, never generate-json-schemas-from-zod.ts: that
// file is an entrypoint whose main() guard fires inside the tsup bundle
// (pinned by autopilot-schema-command.test.ts).
import type { Command } from "commander";
import { generateJsonSchemaText } from "../lib/autopilot/json-schema-text-from-zod.js";
import { AUTOPILOT_SCHEMA_NAMES } from "../lib/autopilot/schemas/index.js";

export type AutopilotSchemaTextOutcome =
  | { ok: true; text: string }
  | { ok: false; message: string };

/** Pure: the schema text for a registered name, or a message naming every valid name. */
export function resolveAutopilotSchemaText(name: string): AutopilotSchemaTextOutcome {
  if (!AUTOPILOT_SCHEMA_NAMES.includes(name)) {
    return {
      ok: false,
      message:
        `Schema "${name}" không tồn tại. Tên hợp lệ: ${AUTOPILOT_SCHEMA_NAMES.join(", ")}. ` +
        "Ví dụ: avatar autopilot schema result",
    };
  }
  return { ok: true, text: generateJsonSchemaText(name) };
}

export function registerAutopilotSchemaCommand(autopilot: Command): void {
  autopilot
    .command("schema <name>")
    .description(
      "In JSON Schema (sinh từ zod, giống templates/autopilot/<name>.schema.json) — hỏi trước khi tạo payload, không dựa trí nhớ",
    )
    .action((name: string) => {
      const outcome = resolveAutopilotSchemaText(name);
      if (!outcome.ok) {
        process.stderr.write(`${outcome.message}\n`);
        process.exitCode = 1;
        return;
      }
      // Raw schema on stdout — meant to be piped (`| python3 -m json.tool`).
      process.stdout.write(outcome.text);
    });
}
